import { useQuery } from '@tanstack/react-query';

import { QueryVariables, StaleTime } from 'queries/types';

import { ticketsInfoQuery } from './queries';

export const useTicketsInfo = (
  variables: QueryVariables<typeof ticketsInfoQuery>,
) => {
  const { data } = useQuery({
    ...ticketsInfoQuery(variables),
    refetchOnWindowFocus: 'always',
    staleTime: StaleTime.THIRTY_SEC,
    enabled: !!variables.eventId && !!variables.ticketIds?.length,
  });

  return {
    info: data?.ticketsInfo,
  };
};
